import enLang from "./entries/en-US";
import TrLang from "./entries/tr_TR";

const AppLocale: Record<string, any> = {
  en: enLang,
  tr: TrLang,
};

export default AppLocale;
